import { responseHandlerDefault } from "./../utils/handler.util";
import { WaterType } from "@/types/waterType.type";
import axios from "./api";

export const postWaterType = (waterType: WaterType): Promise<WaterType> => {
  return axios.post<WaterType>("/watertype/", waterType).then(responseHandlerDefault);
};

export const getWaterTypes = (samplingPointId: number): Promise<WaterType[]> => {
  const params: { samplingPointId?: number } = {};

  if (samplingPointId) {
    params.samplingPointId = samplingPointId;
  }

  return axios.get("/watertype/", { params }).then(responseHandlerDefault);
};
